export const getPhenotype = (): string => {
  const phenotypeOptions = [
    'Moderate phenotype',
    'High phenotype',
    'Low phenotype',
  ];
  // TODO: Implement logic to determine the phenotype
  // for now randomly select a phenotype
  const randomIndex = Math.floor(Math.random() * phenotypeOptions.length);
  return phenotypeOptions[randomIndex];
};
